import { CookieConsentModal } from './CookieConsentModal';

export default CookieConsentModal;
